var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.003,
    height: 14.003,
    viewBox: "0 0 14.003 14.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pencil",
    d: "M13.508-10.719a1.7,1.7,0,0,1,.52,1.244,1.7,1.7,0,0,1-.52,1.244L3.883,1.395.766,1.75a.668.668,0,0,1-.738-.738L.383-2.105l9.625-9.625a1.7,1.7,0,0,1,1.244-.52,1.7,1.7,0,0,1,1.244.52Zm-2.6,3.855-2.27-2.27L2.516-3.008h.957V-1.7H4.785v.957ZM3.473.574,4.02.027V-.93H2.707V-2.242H1.75L1.2-1.7,1.039-.082l.82.82Zm9.434-9.434a.835.835,0,0,0,.246-.615.835.835,0,0,0-.246-.615l-1.039-1.039a.835.835,0,0,0-.615-.246.835.835,0,0,0-.615.246L9.27-9.762l2.27,2.27Z",
    transform: "translate(-0.024 12.25)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.26f1156cf0614fd9a448ee8b2dad23f3.svg";
export { ForwardRef as ReactComponent };